import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-89cacc50"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  href: "/home?view=TeamDashboard",
  class: "btn btn-default-back back-button"
}, " My Team ", -1))
const _hoisted_3 = { class: "cms-session-wheel" }

import axios from "axios";
import { computed, ref, triggerRef, watch } from "vue";
import { csContext } from "../../services/cs-context";
import {
  CmsGoalData,
  CmsTeamPathway,
  CmsTeamPathwayStep,
} from "../../services/cms/cms-type-definitions";
import cms from "../../services/cms/cms";
import { TeamMemberCompletedPathwayStepApiModel } from "../../api-models";
import SessionWheel, { CmsSessionApiModel } from "../sessions/sessions-wheel.vue";
import PathwayWheelHeader from "../../components/cms/pathway-wheel-header.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'pathway-wheel',
  props: {
    doc: {}
  },
  setup(__props: any) {

const props = __props;

const outcome = ref<Partial<CmsGoalData> | null>(null);
// undefined means pending, null means that they have not completed the step.
const memberProgress = ref<(TeamMemberCompletedPathwayStepApiModel | null | undefined)[]>([]);

const wheelColour = computed(
  () => props.doc.data?.goal_relationship.data?.goal_colour || "#B0BB36",
);
const teamId = computed(() => csContext.currentTeam?.id ?? "");
const currentOutcome = computed(() => props.doc.data.goal_relationship.data ?? null);

function updateCompletion(): void {
  if (teamId.value) {
    const tempMemberProgress = props.doc.data.pathway_steps.map(
      () => undefined as TeamMemberCompletedPathwayStepApiModel | null | undefined,
    );

    memberProgress.value = tempMemberProgress;
    props.doc.data.pathway_steps.forEach((step, index) =>
      axios
        .get(
          `/api/TeamMemberCompletedPathwayStep?cmsStepId=${step.pathway_step.id}&cmsPathwayId=${props.doc.id}&teamId=${teamId.value}`,
        )
        .then((value) => {
          memberProgress.value[index] = value.data;
          triggerRef(memberProgress);
        }),
    );
  } else {
    memberProgress.value = props.doc.data.pathway_steps.map(
      () => null as TeamMemberCompletedPathwayStepApiModel | null | undefined,
    );
  }
}

watch(
  () => props.doc,
  () => {
    updateCompletion();
  },
  { immediate: true },
);

const model = computed(() => {
  // If any are undefined, we're still loading.
  if (!memberProgress.value?.every((p) => p !== undefined)) {
    return null;
  }

  const sessions = props.doc.data.pathway_steps.map((step, index): CmsSessionApiModel => {
    const pathwayStep: CmsTeamPathwayStep = step.pathway_step as any;
    const isCompleted = !!memberProgress.value[index];

    return {
      id: pathwayStep.id,
      index,
      shortTitle: cms.asText(pathwayStep.data?.tile_title) || cms.asText(pathwayStep.data.title),
      fullTitle: cms.asText(pathwayStep.data.title),
      availableDescription: [],
      unavailableDescription: [],
      theme: "team-theme",
      availableDescriptionFromCms: step.step_description,
      unavailableDescriptionFromCms: step.step_description,
      durationDescription: "",
      callToAction: "",
      isAvailable: true,
      isCompleted,
      latestSceneIndex: 0,
      imageUrl: props.doc.data?.title_image?.url || pathwayStep.data.title_image.url,
      url: cms.linkResolver(pathwayStep),
      buttonText: cms.asText(step.step_button_text) || "Go",
      itemTypeText: cms.asText(step.step_type_text) || "Step",
    };
  });
  return { sessions };
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _createVNode(PathwayWheelHeader, { currentOutcome: currentOutcome.value }, null, 8, ["currentOutcome"])
    ]),
    _createElementVNode("div", _hoisted_3, [
      (model.value)
        ? (_openBlock(), _createBlock(SessionWheel, {
            key: 0,
            model: model.value,
            "wheel-colour": wheelColour.value,
            includeBackButton: true
          }, null, 8, ["model", "wheel-colour"]))
        : _createCommentVNode("", true)
    ])
  ]))
}
}

})